export const processCustomerContactData = (data) => {
  return {
    ...data,
    updated_at_date: new Date(data.updated_at),
  };
};
